import { FormControl, FormGroup } from '@angular/forms';
import { BlockLoopCustomOption } from '@empathy/survey/base';

import { IBlockLoopCustomOptionForm } from './block-loop-custom-option-form.interface';

export class BlockLoopCustomOptionForm {
  form = new FormGroup<IBlockLoopCustomOptionForm>({
    id: new FormControl<string>(''),
    text: new FormControl<string>('')
  });

  constructor(question?: BlockLoopCustomOption, initId: string = 'opt_1') {
    if (!question) {
      this.form.get('id').setValue(initId);
      return;
    }

    this.form.patchValue(question);
  }
}
